import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import consola from 'consola';
import { logError } from '@/helpers/log-helper';
import productQuery from '~/graphql/product.gql';
import productCarouselsQuery from '~/graphql/product/carousels.gql';
import productImagesQuery from '~/graphql/product/images.gql';
import productOffersQuery from '~/graphql/product/offers.gql';
import productVariantsQuery from '~/graphql/product/variants.gql';
import productsQuery from '~/graphql/products.gql';
function fetchProductCarousels(_x, _x2) {
  return _fetchProductCarousels.apply(this, arguments);
}
function _fetchProductCarousels() {
  _fetchProductCarousels = _asyncToGenerator(function* (context, reference) {
    var profileId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var exclude = arguments.length > 3 ? arguments[3] : undefined;
    var isPrivateSales = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var locale = context.state.i18n.currentLocale.iso;
    try {
      var {
        data
      } = yield context.app.apolloProvider.defaultClient.query({
        query: productCarouselsQuery,
        variables: {
          profileId,
          reference,
          locale,
          exclude,
          isPrivateSales
        }
      });
      return data.product;
    } catch (e) {
      logError({
        msg: e,
        context
      });
      return null;
    }
  });
  return _fetchProductCarousels.apply(this, arguments);
}
function fetchProduct(_x3) {
  return _fetchProduct.apply(this, arguments);
}
function _fetchProduct() {
  _fetchProduct = _asyncToGenerator(function* (_ref) {
    var {
      context,
      reference,
      offer,
      profileId = null,
      withMarketplace = false,
      isPrivateSales = false
    } = _ref;
    var locale = context.state.i18n.currentLocale.iso;
    try {
      var {
        data
      } = yield context.app.apolloProvider.defaultClient.query({
        query: productQuery,
        variables: {
          variantImageTransformation: process.client && context.$cookies.get('smart-crop-variants') ? 'g_auto,c_crop,r_max' : '',
          locale,
          reference,
          offer,
          profileId,
          withMarketplace,
          isPrivateSales
        }
      });
      return data.product;
    } catch (e) {
      consola.error(e);
      logError({
        msg: e,
        context
      });
      return null;
    }
  });
  return _fetchProduct.apply(this, arguments);
}
function fetchProductVariants(_x4, _x5) {
  return _fetchProductVariants.apply(this, arguments);
}
function _fetchProductVariants() {
  _fetchProductVariants = _asyncToGenerator(function* (_ref2, reference) {
    var {
      app,
      getters
    } = _ref2;
    var locale = getters['i18n/locale'].iso;
    try {
      var {
        data
      } = yield app.apolloProvider.defaultClient.query({
        query: productVariantsQuery,
        variables: {
          reference,
          locale
        }
      });
      return data.product;
    } catch (e) {
      consola.error(e);
      logError({
        msg: e,
        context: this
      });
      return null;
    }
  });
  return _fetchProductVariants.apply(this, arguments);
}
function fetchProductImages(_x6, _x7) {
  return _fetchProductImages.apply(this, arguments);
}
function _fetchProductImages() {
  _fetchProductImages = _asyncToGenerator(function* (_ref3, reference) {
    var {
      app,
      getters
    } = _ref3;
    var locale = getters['i18n/locale'].iso;
    try {
      var {
        data
      } = yield app.apolloProvider.defaultClient.query({
        query: productImagesQuery,
        variables: {
          reference,
          locale
        }
      });
      return data.product;
    } catch (e) {
      consola.error(e);
      logError({
        msg: e,
        context: this
      });
      return null;
    }
  });
  return _fetchProductImages.apply(this, arguments);
}
function fetchProducts(_x8, _x9) {
  return _fetchProducts.apply(this, arguments);
}
function _fetchProducts() {
  _fetchProducts = _asyncToGenerator(function* (_ref4, references) {
    var {
      app,
      getters
    } = _ref4;
    var locale = getters['i18n/locale'].iso;
    try {
      var {
        data
      } = yield app.apolloProvider.defaultClient.query({
        query: productsQuery,
        variables: {
          locale,
          references
        }
      });
      return data.products;
    } catch (e) {
      consola.error(e);
      logError({
        msg: e,
        context: this
      });
      return null;
    }
  });
  return _fetchProducts.apply(this, arguments);
}
function fetchProductOffers(_x10, _x11) {
  return _fetchProductOffers.apply(this, arguments);
}
function _fetchProductOffers() {
  _fetchProductOffers = _asyncToGenerator(function* (_ref5, reference) {
    var {
      app,
      getters
    } = _ref5;
    var locale = getters['i18n/locale'].iso;
    try {
      var {
        data
      } = yield app.apolloProvider.defaultClient.query({
        query: productOffersQuery,
        variables: {
          reference,
          locale
        }
      });
      return data.product;
    } catch (e) {
      consola.error(e);
      logError({
        msg: e,
        context: this
      });
      return null;
    }
  });
  return _fetchProductOffers.apply(this, arguments);
}
export { fetchProduct, fetchProductCarousels, fetchProductVariants, fetchProductImages, fetchProductOffers, fetchProducts };